import Vue from 'vue'
import axios from 'axios'
import config from './config'

let isDevelopment = process.env.NODE_ENV === 'development';
let isUAT = process.env.NODE_ENV === 'uat';
let isProduction = process.env.NODE_ENV === 'production';
let apiURL = isDevelopment ? config.API_URL_LOCAL : isUAT ? config.API_URL_UAT : isProduction ? config.API_URL_PRODUCTION : config.API_URL_LOCAL;
apiURL = 'https://d-ecouponapi.aidencreative.com/api';

Vue.prototype.$backendUrl = apiURL;
const jsonRequest = axios.create({
  baseURL: apiURL,
  withCredentials: true, // Sends the cookies
  withXSRFToken: true,   // CRITICAL: Tells modern Axios to read the XSRF cookie and send it back as a header
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
})

export default {
  //account
  async login(payload) {
    await jsonRequest.get('https://d-ecouponapi.aidencreative.com/sanctum/csrf-cookie');
    return await jsonRequest.post('/login', payload);
  },
  logout(payload, config) {
    return jsonRequest.post('/logout', payload, config);
  },
  changePassword(payload, config) {
    return jsonRequest.post('/change-password', payload, config)
  },
  verifyToken(payload, config) {
    return jsonRequest.post('/token/verify', payload, config);
  },
  sendForgotPasswordEmail(payload) {
    return jsonRequest.post('/forgot-password/email', payload);
  },
  resetPassword(payload) {
    return jsonRequest.post('/reset-password', payload);
  },
  verifyResetPasswordLink(payload) {
    return jsonRequest.post('/verify-reset-password-link', payload);
  },

  //merchant
  getAllMerchants(payload, config) {
    return jsonRequest.post('/merchant/all', payload, config);
  },
  getActiveMerchants(payload) {
    return jsonRequest.post('/merchant/list/active', payload);
  },
  getMerchants(payload, config) {
    return jsonRequest.post('/merchant/list', payload, config);
  },
  saveMerchant(payload, config) {
    return jsonRequest.post('/merchant/save', payload, config);
  },
  deleteMerchant(payload, config) {
    return jsonRequest.post('/merchant/delete', payload, config);
  },
  toggleMerchant(payload, config) {
    return jsonRequest.post('/merchant/toggle', payload, config);
  },
  getApiKey(payload, config) {
    return jsonRequest.post('/merchant/api-key', payload, config);
  },
  resetApiKey(payload, config) {
    return jsonRequest.post('/merchant/api-key/reset', payload, config);
  },
  getPinCode(payload, config) {
    return jsonRequest.post('/merchant/pin', payload, config);
  },
  savePinCode(payload, config) {
    return jsonRequest.post('/merchant/pin/save', payload, config);
  },
  async checkMerchantExists(payload) {
    await jsonRequest.get('https://d-ecouponapi.aidencreative.com/sanctum/csrf-cookie');
    return await jsonRequest.post('/merchant/check', payload);
  },

  //merchant user
  getMerchantUsers(payload, config) {
    return jsonRequest.post('/merchant-user/list', payload, config);
  },
  saveMerchantUser(payload, config) {
    return jsonRequest.post('/merchant-user/save', payload, config);
  },
  deleteMerchantUser(payload, config) {
    return jsonRequest.post('/merchant-user/delete', payload, config);
  },
  toggleMerchantUser(payload, config) {
    return jsonRequest.post('/merchant-user/toggle', payload, config);
  },

  //admin user
  getAdminUsers(payload, config) {
    return jsonRequest.post('/admin-user/list', payload, config);
  },
  saveAdminUser(payload, config) {
    return jsonRequest.post('/admin-user/save', payload, config);
  },
  deleteAdminUser(payload, config) {
    return jsonRequest.post('/admin-user/delete', payload, config);
  },
  toggleAdminUser(payload, config) {
    return jsonRequest.post('/admin-user/toggle', payload, config);
  },

  //customer
  getCustomerNames(payload, config) {
    return jsonRequest.post('/customer-names/', payload, config);
  },
  getCustomerEmails(payload, config) {
    return jsonRequest.post('/customer-emails', payload, config);
  },
  getNationalities(payload, config) {
    return jsonRequest.post('/nationalities', payload, config);
  },
  getCustomers(payload, config) {
    return jsonRequest.post('/customer/list', payload, config);
  },
  saveCustomer(payload, config) {
    return jsonRequest.post('/customer/save', payload, config);
  },
  deleteCustomer(payload, config) {
    return jsonRequest.post('/customer/delete', payload, config);
  },
  toggleCustomer(payload, config) {
    return jsonRequest.post('/customer/toggle', payload, config);
  },

  //batch e-coupon
  getBatchEcoupons(payload, config) {
    return jsonRequest.post('/batch-ecoupon/list', payload, config);
  },
  importBatchEcouponData(payload, config) {
    return jsonRequest.post('/batch-ecoupon/import', payload, config);
  },
  getBatchEcouponDetails(payload, config) {
    return jsonRequest.post('/batch-ecoupon/details', payload, config);
  },
  saveBatchEcouponDetails(payload, config) {
    return jsonRequest.post('/batch-ecoupon/details/save', payload, config);
  },
  redeemBatchEcoupon(payload, config) {
    return jsonRequest.post('/batch-ecoupon/redeem', payload, config);
  },
  voidBatchEcoupon(payload, config) {
    return jsonRequest.post('/batch-ecoupon/void', payload, config);
  },

  //flexible e-coupon
  getFlexibleEcoupons(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/list', payload, config);
  },
  addFlexibleEcoupon(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/add', payload, config);
  },
  updateFlexibleEcoupon(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/update', payload, config);
  },
  deleteFlexibleEcoupon(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/delete', payload, config);
  },
  redeemFlexibleEcoupon(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/redeem', payload, config);
  },
  getFlexibleEcouponDetails(payload, config) {
    return jsonRequest.post('/flexible-ecoupon/details', payload, config);
  },

  //report
  getEcouponReport(payload, config) {
    return jsonRequest.post('/report/ecoupon', payload, config);
  },
  getEcouponReconcileReport(payload, config) {
    return jsonRequest.post('/report/ecoupon/reconcile', payload, config);
  },
  exportEcouponReport(payload, token) {
    return jsonRequest.get('/report/ecoupon/export', { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob', params: payload });
  },

  //audit log
  getAuditLogs(payload, config) {
    return jsonRequest.post('/audit-log/list', payload, config);
  },
  exportAuditLog(payload, token) {
    return jsonRequest.get('/audit-log/export', { headers: { Authorization: `Bearer ${token}` }, responseType: 'blob', params: payload });
  },

  //settings
  getSetting(payload, config) {
    return jsonRequest.post('/setting/get', payload, config);
  },
  saveSetting(payload, config) {
    return jsonRequest.post('/setting/save', payload, config);
  }
}


// WEBPACK FOOTER //
// ./src/http-common.js